export default entity => ({
  type: "FAVORITE/ID",
  payload: { ...entity }
});
